import React from "react"
import { spinner, spinnerWrapper } from "./Spinner.css"

export const Spinner: React.FC<{ type?: "componentLevel" | "pageLevel" }> = ({
  type = "componentLevel",
}) => {
  return (
    <div className={spinnerWrapper[type]}>
      <span className={spinner} />
    </div>
  )
}
